// number-one-recommendation-chart.tsx
import { AnalyticsChart } from "./analytics-chart";
import { MetricTerm }     from "../metric-term";
import { useNumberOneRecommendationData } from "@/app/hooks/analytics/useNumberOneRecommendationData";
import { getPerformanceEvents } from "@/app/data/performance-events";

interface Props {
  antennaData?:          any;
  selectedModels?:       string[];
  brandName?:            string;
  onNavigateToInsights?: () => void;
  projectionDate?:       string | null;
}

export function NumberOneRecommendationChart({ antennaData, selectedModels, brandName, onNavigateToInsights, projectionDate }: Props) {
  const { data, isLoading, error } = useNumberOneRecommendationData("full", antennaData, selectedModels);
  const events = getPerformanceEvents(brandName);

  return (
    <AnalyticsChart
      timeSeriesData={data?.timeSeriesData ?? []}
      selectedModels={data?.selectedModels ?? []}
      isLoading={isLoading}
      error={error}
      metricUnit="%"
      metricName="Primary Recommendation"
      insightContext="primary recommendation rate"
      brandName={brandName}
      onNavigateToInsights={onNavigateToInsights}
      projectionDate={projectionDate}
      events={events}
      isIllustrative={data?.isSynthetic}
      incompleteRuns={data?.incompleteRuns}
      rebaselineMarks={data?.rebaselineMarks}
      metricTitle={
        <MetricTerm
          definition="The share of responses where your brand is the explicit primary recommendation: the one the AI endorses when asked for a single best answer."
          calculation="Responses where your brand is identified as the primary recommendation (not just listed), divided by total responses scored, averaged across the AI models measured in this run."
          interpretation="This is the most commercially meaningful metric. A large gap between Top 5 Rate and Primary Recommendation means models know you but cannot justify endorsing you. That is an encoding problem, not a visibility problem."
          goodRange="20% or higher is strong. 10-19% is developing. Below 10% means models aren't confident enough to commit to a primary endorsement even when they list you."
          onOpenAIChat={() => {}}
        >
          Primary Recommendation
        </MetricTerm>
      }
    />
  );
}